import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "首页", to: "/" },
  { label: "事件档案", to: "/topics" },
  { label: "吃瓜百科", to: "/#glossary" },
  { label: "关于我们", to: "/about" },
];

export default function SiteHeader() {
  const { pathname } = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const isHome = pathname === "/";
  const overlay = isHome && !scrolled;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  const linkColor = overlay
    ? "text-background-50 hover:text-accent-300"
    : "text-foreground-700 hover:text-primary-600";

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        overlay
          ? "border-b border-white/10 bg-transparent"
          : "border-b border-background-200 bg-background-50/95 backdrop-blur"
      }`}
    >
      <div className="mx-auto flex h-16 w-full items-center justify-between gap-4 px-4 md:h-[72px] md:px-6">
        <Link to="/" className="flex shrink-0 items-center gap-2.5" aria-label="瓜田观察站 首页">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-md text-lg ${
              overlay ? "bg-background-50/15 text-accent-300" : "bg-primary-500 text-background-50"
            }`}
          >
            <i className="ri-leaf-line" aria-hidden="true"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-display text-lg tracking-wide md:text-xl ${
                overlay ? "text-background-50" : "text-foreground-950"
              }`}
            >
              瓜田观察站
            </span>
            <span
              className={`mt-0.5 hidden font-label text-[10px] tracking-[0.2em] sm:block ${
                overlay ? "text-background-200" : "text-foreground-500"
              }`}
            >
              围观不迷路
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navLinks.map((link) => (
            <Link
              key={link.label}
              to={link.to}
              className={`whitespace-nowrap rounded-md px-3.5 py-2 font-label text-sm transition-colors duration-200 ${linkColor}`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/topics"
            className={`hidden h-9 w-9 items-center justify-center rounded-md transition-colors duration-200 sm:flex ${
              overlay
                ? "text-background-50 hover:bg-white/10"
                : "text-foreground-600 hover:bg-background-100"
            }`}
            aria-label="搜索事件档案"
          >
            <i className="ri-search-line text-base" aria-hidden="true"></i>
          </Link>
          <Link
            to="/about#contact"
            className={`hidden whitespace-nowrap rounded-md px-4 py-2 font-label text-sm font-medium transition-colors duration-200 md:inline-flex ${
              overlay
                ? "bg-background-50 text-primary-700 hover:bg-accent-100"
                : "bg-primary-500 text-background-50 hover:bg-primary-600"
            }`}
          >
            订阅更新
          </Link>
          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            className={`flex h-9 w-9 items-center justify-center rounded-md md:hidden ${
              overlay ? "text-background-50" : "text-foreground-800"
            }`}
            aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
            aria-expanded={menuOpen}
          >
            <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-xl`} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 md:hidden">
          <nav className="flex flex-col" aria-label="移动端导航">
            {navLinks.map((link) => (
              <Link
                key={link.label}
                to={link.to}
                className="border-b border-background-100 py-3 font-label text-sm text-foreground-800 transition-colors hover:text-primary-600"
              >
                {link.label}
              </Link>
            ))}
          </nav>
          <Link
            to="/about#contact"
            className="btn-primary mt-4 w-full"
          >
            订阅更新
          </Link>
        </div>
      )}
    </header>
  );
}